import PicklistMetadata from "../PicklistMetadata";

// Which object to relate this one to.
//
// LONG LIST, because a realm holds thousands of objects and a dropdown of them is not a chooser.
// The long-list control opens a searchable grid instead, which is the only way to find "the SOP
// about gowning" among eight hundred documents.
//
// typeValue IS ObjectUSID, NOT USID, and the distinction is the whole correctness of the feature.
// An edge joins LOGICAL objects, so it survives every revise on either end; storing the revision
// USID would pin the relationship to one revision and silently orphan it the next time somebody
// revised the other record.
//
// CURRENT REVISIONS ONLY. Without this the picker lists every revision of everything -- the same
// document eight times, once per revision, indistinguishable in a dropdown.
class RelatedObjectPicklistMetadata extends PicklistMetadata {
    constructor() {
        super();

        this.name = "RelatedObject";
        this.bounded = true;
        this.enterpriseComponent = "RelatableObject";
        this.longList = true;
        this.noDelete = true;
        this.noUpdate = true;
        this.noInsert = true;
        this.noMerge = true;
        this.useRealm = false;
        // The current-revision floor lives in the component, not here -- a search specification is
        // what the CHOOSER types, and mixing the two let a search clear the floor.
        this.searchSpecification = null;
        this.sortSpecification = {"Name": "ASC"};
        this.static = false;
        this.typeField = "Name";
        this.typeValue = "ObjectUSID";
        this.typeValue2 = null;
        this.visibilityType = null;
        this.allowNoSelection = false;
        this.allowNoSelectionValue = null;
        this.allowNoSelectionDisplayValue = null;
    }
}

export default RelatedObjectPicklistMetadata;
